import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import appUrls from '../config/urls';
import { CCLineDetailsNotesDto } from '../data/models/ccline-details-notes-dto';

@Injectable({
  providedIn: 'root'
})
export class LineDetailsService {
  provisions: any[];
  lineId: number;
  ipAddress: string;
  lineName: string;


  constructor(private http: HttpClient) { }
  getAccountTrafficData() {
    let url = appUrls.lineDetails.getAccountGraphData;
    return this.http.get(url );
  }

  getLineDetails(lineId) {
    //let url = appUrls.lineDetails.getLineDetails + "?id=" + lineId;
    let url = appUrls.lineDetails.ccLineSummery + lineId;
    return this.http.get(url);
  }


  getLeasedLinesMonitoringSummary() {
    let url = appUrls.lineDetails.leasedLinesSummary;
    return this.http.get(url);
  }



}
